import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Module } from '../../../models/modules';
import { KONTRACTOR_API } from '../../../common/utils/api.bobcat';
import { Widget } from '../../../models/form';

@Component({
  selector: 'app-vertical-select-image',
  templateUrl: './vertical-select-image.component.html',
  styleUrls: ['./vertical-select-image.component.scss']
})
export class VerticalSelectImageComponent implements OnInit {
  private baseHref = KONTRACTOR_API.baseHref;
  @Input() multiple: boolean = false;
  @Input() widget: Widget;
  @Input() data: string | Array<string> = null;
  @Output() updateData = new EventEmitter();

  constructor() { }

  ngOnInit() { }

  selectModule(data: string) {
    if (this.multiple == false) {
      this.data = data;
    }
    else {
      if (!(this.data instanceof Array)) {
        this.data = [];
      }
      if (this.data.indexOf(data) == -1) {
        this.data.push(data);
      }
      else {
        this.data.splice(this.data.indexOf(data), 1)
      }

    }
    this.updateData.emit(this.data);
  }

  isSelected(value) {
    if (this.data instanceof Array) {
      return (this.data.indexOf(value) != -1);
    }
    else {
      return (this.data == value);
    }
  }

  getValue() {
    if ("choices" in this.widget) {
      return this.widget.choices;
    }
    else if ("values" in this.widget) {
      return this.widget.values;
    }
    else {
      return [];
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/components/form/vertical-select-image/vertical-select-image.component.ts